import { Button, Col, Form, Input, notification, Row, Select, Switch } from "antd";
import { useEffect, useState } from "react";
import { CloseCircleOutlined } from '@ant-design/icons';
import { addMeasurementTypeApi, listOfMeasurementsUnitApi, updateMeasurementTypeApi } from "../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, MEASUREMENT_TYPE_IMAGE_BASE_URL, NUMBER_AND_FRACTIONAL_PATTERN } from "../../../../config/constant";

export const AddMeasurementsTypes = (props) => {
    const [form] = Form.useForm();
    const { Option } = Select;

    const [measurementsUnit, setMeasurementsUnit] = useState([])
    const [isDecimalStatus, setIsDecimalStatus] = useState(false)

    const [priviewImg, setPriviewImg] = useState()
    const [file, setfile] = useState()

    const [unit, setUnit] = useState("");
    const [minValue, setMinValue] = useState("");
    const [maxValue, setMaxValue] = useState("");
    const [formula, setFormula] = useState("");
    const [memberList, setMemberList] = useState([{
        unit: unit,
        minValue: minValue,
        maxValue: maxValue,
        formula: formula,
    }]);
    const [measurementsTypeUnit, setMeasurementsTypeUnit] = useState([
        // { "measurements_type_id": 0, "min_value": 0, "max_value": 0 }
        { "unit_id": 0, "min_value": 0, "max_value": 0 }
    ]);
    const [familyMemberData, setFamilyMemberData] = useState([
        {
            unit: unit,
            minValue: minValue,
            maxValue: maxValue,
            formula: formula,
        },
    ]);

    //  fill data for edit Measurement type
    //======================================
    useEffect(() => {

        if (props.editMeasurementsTypeRecord) {
            resetData()
            let record = props.editMeasurementsTypeRecord

            form.setFieldsValue({
                "name": record.name,
                "measurements_type_unit": record.measurements_type_unit,
            })
            setIsDecimalStatus(record.isDecimal)
            setFamilyMemberData(record.measurements_type_unit)
            setMeasurementsTypeUnit(record.measurements_type_unit)
            setfile(MEASUREMENT_TYPE_IMAGE_BASE_URL + record.image)
            // setPriviewImg('http://localhost:8000/storage/' + record.image)
            setMemberList(record.measurements_type_unit)

            if (record.measurements_type_unit && record.measurements_type_unit.length > 0) {
                record.measurements_type_unit.map((element, index) => {
                    form.setFieldValue('unit' + index, element?.unit?.id)
                    form.setFieldValue('minValue' + index, parseFloat(element.min_value))
                    form.setFieldValue('maxValue' + index, parseFloat(element.max_value))
                    form.setFieldValue('formula' + index, element?.formula)
                })
            }
        }
    }, [props.editMeasurementsTypeRecord])


    // get the list of alll available measurements Unit 
    //==============================
    const getListOfMeasurementsUnit = () => {
        listOfMeasurementsUnitApi()
            .then((res) => {
                if (res.status === 200) {
                    setMeasurementsUnit(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    useEffect(() => {
        getListOfMeasurementsUnit()
    }, [])

    // clear all form when user click on add button 
    //==============================
    useEffect(() => {
        if (props.buttonName == 'SAVE') {
            resetData()
        }
    }, [props.buttonName])

    // add new row for measurement data
    //==============================
    const addNewMember = () => {
        const currentMember = [...memberList];
        currentMember.push({
            unit: "",
            minValue: "",
            maxValue: "",
            formula: ""
        });
        setMemberList(currentMember);
        // console.log(currentMember);
        //=====================
        // total family detail state
        const TotalFamilyMemberDetails = [...familyMemberData];

        TotalFamilyMemberDetails.push({
            unit: "",
            minValue: "",
            maxValue: "",
            formula: ""
        });
        setFamilyMemberData(TotalFamilyMemberDetails);

        measurementsTypeUnit.push({ "unit_id": 0, "min_value": 0, "max_value": 0, "formula": "" })
        // setMeasurementsTypeUnit([...measurementsTypeUnit, { "measurements_type_id": 0, "min_value": 0, "max_value": 0 }]);
    };

    // ================================
    // get field name its value and index to create array of object
    // ================================
    const handleTotalFamilyMemberDetail = (
        fieldName,
        value,
        index
    ) => {
        // measurementsTypeUnit
        var tempData = familyMemberData[index];
        tempData = { ...tempData, [fieldName]: value };
        // console.log(tempData);
        // let data = measurements_type_unit[index].

        if (fieldName == 'unit') {
            let record = measurementsTypeUnit[index]
            record.unit_id = value
            // let record = measurementsTypeUnit[index]
        }
        if (fieldName == 'min_value') {
            let record = measurementsTypeUnit[index]
            record[fieldName] = parseInt(value)
        }
        if (fieldName == 'max_value') {
            let record = measurementsTypeUnit[index]
            record[fieldName] = parseInt(value)
        }
        if (fieldName == 'formula') {
            let record = measurementsTypeUnit[index]
            record.formula = value
        }
        familyMemberData[index] = tempData;
        console.log(familyMemberData);
    };
    // ================================
    // code to remove member 
    // ================================
    const removeMember = (id) => {
        let currentMember = [...memberList];
        currentMember.splice(id, 1);
        setMemberList(currentMember);
        //=====remove from total family member detail state
        let totalMember = [...familyMemberData];
        totalMember.splice(id, 1);
        setFamilyMemberData(totalMember);

        // let record = measurementsTypeUnit[id]
        //  delete measurementsTypeUnit[id];
        // setMeasurementsTypeUnit(updatemeasurementsTypeUnit)
        measurementsTypeUnit.splice(id, 1);

    };

    // handle submit
    //==============================
    const onFinish = (values) => {

        // console.log(measurementsTypeUnit);
        // // let MeasurementsUnitData = {}
        // const formData = new FormData()
        // formData.append('name', values.name)
        // // if(props)
        // formData.append('image', file)
        // // formData.append('image', file.name)
        // formData.append('isDecimal', isDecimalStatus)
        // formData.append('status', true)
        // formData.append('measurements_type_unit', JSON.stringify(measurementsTypeUnit))

        if (props.buttonName == 'SAVE') {
            const formData = new FormData()
            formData.append('name', values.name)
            formData.append('image', file)
            formData.append('isDecimal', isDecimalStatus)
            formData.append('status', true)
            formData.append('measurements_type_unit', JSON.stringify(measurementsTypeUnit))
            addMeasurementTypeApi(formData)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Measurements Types added successfully",
                        });
                        props.getListOfMeasurementTypes()
                        resetData()
                        props.setIsModalVisible(false)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const formData = new FormData()
            formData.append('name', values.name)
            // check if user update image if true then pass updated object of image not pass image field
            // if (file !== 'http://localhost:8000/storage/' + props?.editMeasurementsTypeRecord?.image) {

            if (priviewImg) {
                formData.append('image', file)
            } else {
                formData.append('image', '')
            }
            formData.append('isDecimal', isDecimalStatus)
            formData.append('status', true)
            // remove measurements_type_id fields from objects
            measurementsTypeUnit.map((element) => (
                delete element.measurements_type_id,
                delete element.created_at,
                delete element.updated_at,
                delete element?.unit?.created_at,
                delete element?.unit?.updated_at
            )
            )

            formData.append('measurements_type_unit', JSON.stringify(measurementsTypeUnit))

            updateMeasurementTypeApi(props.editMeasurementsTypeRecord.id, formData)
                .then((res) => {
                    if (res.status == 200) {
                        props.setButtonName("SAVE")
                        notification.success({
                            message: "Measurement Update successfully",
                        });
                        props.getListOfMeasurementTypes()
                        props.setIsModalVisible(false)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const resetData = () => {
        form.resetFields()
        setPriviewImg('')
        setfile('')
        setMeasurementsTypeUnit([])
        setMeasurementsTypeUnit([{ "unit_id": 0, "min_value": 0, "max_value": 0 }])
    };

    // function to display an selected image
    //==============================
    const imagePreview = (e) => {
        const objectUrl = URL.createObjectURL(e.target.files[0])
        setPriviewImg(objectUrl)
        setfile(e.target.files[0])
    }
    return (
        <Form
            name="addPlanPricingForm"
            className="addPlanPricingForm"
            form={form}
            onFinish={onFinish}
        >
            <div className="logoSection">
                <h4 className="mb-0">{props.buttonName == "SAVE" ? "Add" : "Update"} Measurements Types</h4>
            </div>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3" >
                <Col xs={24} md={16} xl={11} xxl={8}>
                    <label className="form-input-label">
                        Name
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Measurements Type Name!",
                            },
                            {
                                pattern: CHARACTER_PATTERN,
                                message: CHARACTER_PATTERN_MESSAGE,
                            }
                        ]}
                    >
                        <Input placeholder="Enter Measurements Type Name" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={16} xl={11} xxl={8}>
                    <label className="form-input-label">
                        Image
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="image"
                        rules={[
                            {
                                required: props?.editMeasurementsTypeRecord?.image ? false : true,
                                message: "Please Select Image!",
                            },
                        ]}
                    >
                        <Input type="file" onChange={(e) => imagePreview(e)} className="mt-2 p-1" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={16} xl={11} xxl={4}>
                    {file && (
                        <img src={priviewImg || file} alt="Measurement Type Image" width={100} />
                    )}
                </Col>
                <Col xs={24} md={16} xl={11} xxl={4} className="align-self-center">
                    <label className="form-input-label">
                        Decimal
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="isDecimal"
                    // rules={[
                    //     {
                    //         required: true,
                    //         message: "Please Select isDecimal!",
                    //     },
                    // ]}
                    >
                        <Switch checked={isDecimalStatus} onChange={(e) => setIsDecimalStatus(e)} />
                    </Form.Item>
                </Col>
                {/* <Col xs={24} md={16} xl={11} xxl={12}>
                    {file && (
                        <img src={priviewImg || ''} alt="360" width={200} />
                    )}
                </Col> */}
                {memberList.map((member, index) => (
                    <>
                        <Col md={12} lg={6} xl={7}>
                            <label className="form-input-label">Select Unit</label>
                            <br />
                            <Form.Item
                                name={"unit" + index}
                                key={index}
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select Unit",
                                    },
                                ]}
                            // initialValue={member.unit}
                            >
                                <Select
                                    className="w-100 mt-1 pt-1"
                                    placeholder="Select Unit"
                                    // defaultValue=""
                                    // onChange={(e) => handleFormOnChange("relation", e)}
                                    onChange={(e) =>
                                        handleTotalFamilyMemberDetail("unit", e, index)
                                    }
                                >
                                    <Option value="" disabled hidden>
                                        Select Unit
                                    </Option>
                                    {measurementsUnit.length > 0 && measurementsUnit.map((option) =>
                                        <Option value={option.id}>{option.name}</Option>
                                    )
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col md={12} lg={7} xl={4}>
                            <label className="form-input-label">Min Value</label>
                            <Form.Item
                                name={"minValue" + index}
                                key={index}
                                rules={[
                                    {
                                        required: true,
                                        message: "Please insert Minimum Value!",
                                    },
                                    {
                                        pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                        message: "Please insert valid Value!",
                                    }
                                ]}
                            // initialValue={member.minValue}
                            >
                                <Input
                                    placeholder="Minimum Value"
                                    onChange={(e) =>
                                        // handleFormOnChange("state_hrd", e.target.value)
                                        handleTotalFamilyMemberDetail("min_value", e.target.value, index)
                                    }
                                    className="mt-2 p-2"
                                // value={member.name}
                                />
                            </Form.Item>
                        </Col>

                        <Col md={12} lg={8} xl={4}>
                            <label className="form-input-label">
                                Max Value
                            </label>
                            <Form.Item
                                name={"maxValue" + index}
                                key={index}
                                rules={[
                                    {
                                        required: true,
                                        // pattern: new RegExp(/[0-9]/),
                                        message: "Please insert Maximum Value!",
                                    },
                                    {
                                        pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                        message: "Please insert valid Value!",
                                    }
                                ]}
                                initialValue={member.maxValue}
                            >
                                <Input
                                    placeholder="Maximum Value"
                                    // onChange={(e) =>
                                    //   handleFormOnChange("contact", e.target.value)
                                    // }
                                    onChange={(e) =>
                                        // handleFormOnChange("state_hrd", e.target.value)
                                        handleTotalFamilyMemberDetail(
                                            "max_value",
                                            e.target.value,
                                            index
                                        )
                                    }
                                    className="mt-2 p-2"
                                    value={maxValue}
                                />
                            </Form.Item>
                        </Col>
                        <Col md={12} lg={8} xl={8}>
                            <label className="form-input-label">
                                formula
                            </label>
                            <Form.Item
                                name={"formula" + index}
                                key={index}
                                rules={[
                                    {
                                        required: false,
                                        message: "Please insert formula!",
                                    },
                                    {
                                        pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                        message: "Please insert valid Value!",
                                    }
                                ]}
                                initialValue={member.formula}
                            >
                                <Input
                                    placeholder="Enter Formula"
                                    // onChange={(e) =>
                                    //   handleFormOnChange("contact", e.target.value)
                                    // }
                                    onChange={(e) =>
                                        // handleFormOnChange("state_hrd", e.target.value)
                                        handleTotalFamilyMemberDetail(
                                            "formula",
                                            e.target.value,
                                            index
                                        )
                                    }
                                    className="mt-2 p-2"
                                    value={formula}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={3} xl={1}>
                            {/* minimum 1 row is required so remove delete button from first row  */}
                            {index !== 0 && (
                                <Button
                                    className="form-delete-btn"
                                    onClick={() => removeMember(index)}
                                    icon={<CloseCircleOutlined className="form-delete-btn" />}
                                >

                                    {/* Delete */}

                                </Button>
                            )}
                        </Col>
                    </>
                ))}
                <Col md={24} lg={24} xl={24} className="text-center">
                    <Button
                        disabled={memberList.length > 1}
                        className="add-new-member-btn"
                        onClick={() => addNewMember()}
                    >
                        Add
                    </Button>
                </Col>

                <Col span={24} className="text-center">
                    <Button htmlType="submit" className="submit-button b-0 rounded">
                        {/* {props.editMeasurementsTypeRecord ? 'UPDATE' : "SA  VE"} */}
                        {props.buttonName}
                    </Button>
                    {/* <Button onClick={() => resetData()} className="reset-button ms-4 b-0 rounded">
                        RESET
                    </Button> */}
                </Col>
            </Row>
        </Form>
    )
}
